import { useQuery } from "@tanstack/react-query";
import { useServerFn } from "@tanstack/react-start";
import { MayaMark } from "@/components/site/BrandLockup";
import { usePublishedGuide } from "@/lib/published-guide";
import { useTranslation } from "react-i18next";
import { getLiveCheckoutAccess } from "@/lib/bokun-live-booking.functions";

const TXT: Record<string, string> = {
  es: "Reserva directo y recibe gratis la audioguía de Maya",
  en: "Book direct and get Maya's audio guide free",
  fr: "Réservez en direct et recevez l'audioguide de Maya offert",
  de: "Direkt buchen und Mayas Audioguide gratis erhalten",
  it: "Prenota direttamente e ricevi gratis l'audioguida di Maya",
  pt: "Reserve direto e receba grátis o audioguia da Maya",
};

/** Solo se muestra cuando este visitante puede pagar en el checkout propio (donde aplica el beneficio). */
export function DirectGuideBenefit({ className = "", tourSlug }: { className?: string; tourSlug: string }) {
  const published = usePublishedGuide(tourSlug);
  const { i18n } = useTranslation();
  const fetchAccess = useServerFn(getLiveCheckoutAccess);
  const { data } = useQuery({
    queryKey: ["live-checkout-access-benefit"],
    queryFn: () => fetchAccess(),
    staleTime: 5 * 60_000,
  });
  if (!data?.allowed || !published) return null;
  return (
    <span className={`inline-flex items-center gap-1.5 ${className}`}>
      <MayaMark size={22} /> {TXT[i18n.language.slice(0, 2)] ?? TXT.es}
    </span>
  );
}
